import React from 'react';
import { Select, MenuItem } from '@material-ui/core';
import { SEGMENT_OPTIONS, SEGMENT_CATEGORY_MAP } from '../constants';

// Custom edit cell component for segment dropdown
const SegmentEditCell = ({ id, value, field, api }) => {
  const handleChange = (event) => {
    const newValue = event.target.value;
    api.setEditCellValue({ id, field, value: newValue });
    // Close edit mode immediately after selection
    api.commitCellChange({ id, field });
    api.setCellMode(id, field, 'view');
  };

  const handleClose = () => {
    api.commitCellChange({ id, field });
    api.setCellMode(id, field, 'view');
  };

  return (
    <Select
      value={value || ''}
      onChange={handleChange}
      onClose={handleClose}
      fullWidth
      open
      autoFocus
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        }
      }}
    >
      {SEGMENT_OPTIONS.map((segment) => {
        const category = SEGMENT_CATEGORY_MAP[segment] || '';
        const displayText = category ? `${segment} (${category})` : segment;
        return (
          <MenuItem key={segment} value={segment}>
            {displayText}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default SegmentEditCell;
